import { Injectable } from "@angular/core";
import { ChannelType } from "@shared/clickar-constants";
import { UserDTO } from "@shared/model/user.model";
import { VehicleShowcaseDTO } from "@shared/model/vehicle.model";
import { AuctionService } from "@shared/services/auction/auction.service";
import { ShowcaseService } from "@shared/services/showcase/showcase.service";
import { TemplateService } from "@shared/services/template/template.service";
import { UserApiService } from "@shared/services/users/userApi.service";
import { VehicleService } from "@shared/services/vehicle/vehicle.service";
import { Observable } from "rxjs";

@Injectable({
	providedIn: "root"
})
export class ApiService {
	constructor(
		private auctionService: AuctionService,
		private userApiService: UserApiService,
		private showcaseService: ShowcaseService,
		private templateService: TemplateService,
		private vehicleService: VehicleService
	) { }

	acceptedRegulationUsingGET = (idAuction: number) => this.auctionService.acceptedRegulationUsingGET(idAuction);

	getLink = (idPurchase: number) => this.userApiService.getLink(idPurchase);

	acceptRegulationUsingPATCH = (idAuction: number) => this.auctionService.acceptRegulationUsingPATCH(idAuction);

	getUserUsingGET = () => this.userApiService.getUserUsingGET();

	isLoggedInUsingGET = () => this.userApiService.isLoggedInUsingGET();

	getObservedAuctionLotUsingPOST = (idAuction: number) => this.auctionService.getObservedAuctionLotUsingPOST(idAuction);

	getRandomVehicleUsingGET = (idAuctions: number[]) => this.auctionService.getRandomVehicleUsingGET(idAuctions);

	getRunningAuctionsUsingGET = () => this.auctionService.getRunningAuctionsUsingGET();

	makeOffer = (idAuction: number, idLot: number, offer: number, clickAndBuy: boolean) => this.auctionService.makeOfferUsingPOST(idAuction, idLot, offer, clickAndBuy);

	observeAuctionLotUsingPOST = (endObservation: boolean, idAuction: number, idLot: number) => this.auctionService.observeAuctionLotUsingPOST(endObservation, idAuction, idLot);

	getAuctionFullSearchUsingGET = (idAuction: number, brand?: string, licensePlate?: string, model?: string, region?: string, state?: string, idVehicle?: number, frame?: string) => this.auctionService.getAuctionFullSearchUsingGET(idAuction, brand, licensePlate, model, region, state, idVehicle, frame);

	getAuctionFullUsingGET = (idAuction: number) => this.auctionService.getAuctionFullUsingGET(idAuction);

	getObservedAuctionsLotsUsingGET = () => this.auctionService.getObservedAuctionsLotsUsingGET();

	isShowcaseOpenUsingGET = () => this.showcaseService.isShowcaseOpenUsingGET();

	showcaseBuy = (idVehicle: number) => this.showcaseService.clickAndBuy(idVehicle);

	getPartnersUsingGET = (country: string) => this.templateService.getPartnersOpenUsingGET(country);

	getShowcaseUsingGET = (idMarket?: string) => this.showcaseService.getShowcaseUsingGET(idMarket);

	searchVehiclesUsingGET = (area?: string, brand?: string, licensePlate?: string, maxDamage?: number, maxMix?: number, maxPrice?: number, minDamage?: number, minMix?: number, minPrice?: number, model?: string, state?: string, vehicleCode?: number, frame?: string): Observable<VehicleShowcaseDTO[]> => this.showcaseService.searchVehiclesUsingGET(area, brand, licensePlate, maxDamage, maxMix, maxPrice, minDamage, minMix, minPrice, model, state, vehicleCode, frame);

	getTimeUsingGET = () => this.auctionService.getTimeUsingGET();

	acceptedShowcaseRegulationUsingGET = () => this.showcaseService.acceptedRegulationUsingGET();

	editUserUsingPUT = (userDTO: UserDTO) => this.userApiService.editUserUsingPUT(userDTO);

	getVehicle = (idVehicle: number) => this.vehicleService.getVehicle(idVehicle);

	getVehicleDetailsUsingGET = (idVehicle: number) => this.vehicleService.getVehicleDetailsUsingGET(idVehicle);

	getPurchasesUsingGET = (auctionName?: string, channel?: ChannelType, fromDate?: Date, idVehicle?: number, frame?: string, licensePlate?: string, toDate?: Date) => this.auctionService.getPurchasesUsingGET(auctionName, channel, fromDate, idVehicle, frame, licensePlate, toDate);

	getGeolocationUsingGET = () => this.userApiService.getGeolocationUsingUsingGET();
}